import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@utils/auth';
import { canRedirect, startNavigation, markRedirect, endNavigation } from '../utils/navigation-guard';
import { authService } from '@services/api';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    // Prevenir redirecionamentos concorrentes
    if (!canRedirect(1500)) {
      console.log('🔄 Redirecionamento bloqueado pelo navigation guard');
      return;
    }

    startNavigation('/');

    try {
      if (!isAuthenticated()) {
        markRedirect();
        throw redirect({ to: '/login' });
      }

      // Verificar seleção de estabelecimento apenas se autenticado
      if (authService.needsEstablishmentSelection()) {
        markRedirect();
        throw redirect({ to: '/selecionar-estabelecimento' });
      }

      markRedirect();
      throw redirect({ to: '/dashboard' });
    } finally {
      // Pequeno delay para garantir que o redirecionamento inicie
      setTimeout(endNavigation, 100);
    }
  },
});
